import dayjs from "dayjs";
import { BellRing, CalendarPlus, X } from "lucide-react";
import { AED } from "../../lib/api";

const renewsIn = (daysLeft) => {
  if (daysLeft === 0) return "today";
  const plural = daysLeft > 1 ? "s" : "";
  return `in ${daysLeft} day${plural}`;
};

export const RenewalBanner = ({ reminders, dismissed, busy, onExtend, onDismiss }) => (
  <>
    {reminders.filter((r) => !dismissed.includes(r.booking_ref)).map((r) => (
      <div key={r.booking_ref} className="bg-[#FFDC00]/25 border border-[#FFDC00] rounded-lg p-4 mb-4 flex flex-wrap items-center gap-3" data-testid="renewal-reminder-banner">
        <BellRing className="w-5 h-5 text-[#144733] shrink-0" />
        <div className="flex-1 min-w-[220px] text-sm text-[#0F1E17]">
          <strong>Your {r.vehicle} subscription renews {renewsIn(r.days_left)}</strong> ({dayjs(r.renew_date).format("DD MMM YYYY")}).
          Monthly subscriptions auto-renew every 30 days — extend now or contact us to arrange return.
          <span className="text-xs text-[#57685e]"> ~{AED(r.monthly_estimate)}/month</span>
        </div>
        <button onClick={() => onExtend(r.booking_ref)} disabled={busy}
          className="btn-cta rounded px-4 py-2.5 text-xs flex items-center gap-1.5" data-testid="renewal-extend-btn">
          <CalendarPlus className="w-4 h-4" /> Extend 1 month
        </button>
        <button onClick={() => onDismiss(r.booking_ref)} className="text-[#57685e] hover:text-[#144733]" data-testid="renewal-dismiss-btn">
          <X className="w-4 h-4" />
        </button>
      </div>
    ))}
  </>
);
